import api from '../../utils/api';
import {
    GET_LIST_CUSTOMER_CARE_CATEGORY,
    GET_SPECIFIC_CUSTOMER_CARE_CATEGORY,
    UPDATE_SPECIFIC_CUSTOMER_CARE_CATEGORY,
    CREATE_NEW_CUSTOMER_CARE_CATEGORY,
    REMOVE_CUSTOMER_CARE_CATEGORY,
    GET_CUSTOMER_CARE_CATEGORY_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách danh mục CSKH theo bộ lọc
 */
export const getListCustomerCareCategory = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/customer-care-categories', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_CUSTOMER_CARE_CATEGORY, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách danh mục CSKH');
            reject(err);
        });
    });
};

/**
 * Lấy danh mục CSKH cụ thể theo ID
 */
export const getSpecificCustomerCareCategory = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/customer-care-categories/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_CUSTOMER_CARE_CATEGORY, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể lấy chi tiết danh mục CSKH');
            reject(err);
        });
    });
};

/**
 * Lấy danh sách danh mục CSKH đang hoạt động
 */
export const getCustomerCareCategoryActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/customer-care-categories/active', { params: filter }).then(res => {
            dispatch({ type: GET_CUSTOMER_CARE_CATEGORY_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách danh mục CSKH đang hoạt động');
            reject(err);
        });
    });
};

/**
 * Tạo mới danh mục CSKH
 */
export const createCustomerCareCategory = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/customer-care-categories', data).then(res => {
            dispatch({ type: CREATE_NEW_CUSTOMER_CARE_CATEGORY, payload: res.data.data });
            NotificationManager.success("Thêm mới danh mục CSKH thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Thêm mới danh mục CSKH thất bại');
            reject(err);
        });
    });
};

/**
 * Cập nhật danh mục CSKH
 */
export const updateCustomerCareCategory = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/customer-care-categories/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_CUSTOMER_CARE_CATEGORY, payload: res.data.data });
            NotificationManager.success("Cập nhật danh mục CSKH thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Cập nhật danh mục CSKH thất bại');
            reject(err);
        });
    });
};

/**
 * Xoá một hoặc nhiều danh mục CSKH
 */
export const removeCustomerCareCategory = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/customer-care-categories`, { data: { ids } }).then(res => {
            dispatch({ type: REMOVE_CUSTOMER_CARE_CATEGORY, payload: ids });
            NotificationManager.success("Xoá danh mục CSKH thành công!");
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || 'Xoá danh mục CSKH thất bại');
            reject(err);
        });
    });
};
